import { render } from "./Form.vue?vue&type=template&id=6ed21a82&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=6ed21a82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6ed21a82"

export default script